import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Which viewport's world a subtree is in. The canvas's renderer draws the root viewport, so only the
 * root world mounts the compositor. A sub-viewport's pass renders its own target with its own
 * samples and tone mapping (`subviewport/Component.tsx`).
 */
import { createContext, useContext } from 'react';
const WorldKindContext = createContext('root');
WorldKindContext.displayName = 'WorldKindContext';
export function WorldKindProvider({ world, children }) {
    return _jsx(WorldKindContext.Provider, { value: world, children: children });
}
export function useWorldKind() {
    return useContext(WorldKindContext);
}
//# sourceMappingURL=WorldKindContext.js.map